"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversationMessageDtoRoleEnum = void 0;
exports.instanceOfConversationMessageDto = instanceOfConversationMessageDto;
exports.ConversationMessageDtoFromJSON = ConversationMessageDtoFromJSON;
exports.ConversationMessageDtoFromJSONTyped = ConversationMessageDtoFromJSONTyped;
exports.ConversationMessageDtoToJSON = ConversationMessageDtoToJSON;
exports.ConversationMessageDtoToJSONTyped = ConversationMessageDtoToJSONTyped;
const ToolCallDto_1 = require("./ToolCallDto");
const ConversationMessageProfileDto_1 = require("./ConversationMessageProfileDto");
/**
 * @export
 */
exports.ConversationMessageDtoRoleEnum = {
    User: 'user',
    Assistant: 'assistant'
};
/**
 * Check if a given object implements the ConversationMessageDto interface.
 */
function instanceOfConversationMessageDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('role' in value) || value['role'] === undefined)
        return false;
    if (!('content' in value) || value['content'] === undefined)
        return false;
    return true;
}
function ConversationMessageDtoFromJSON(json) {
    return ConversationMessageDtoFromJSONTyped(json, false);
}
function ConversationMessageDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'role': json['role'],
        'content': json['content'],
        'toolCalls': json['toolCalls'] == null ? undefined : (json['toolCalls'].map(ToolCallDto_1.ToolCallDtoFromJSON)),
        'profile': json['profile'] == null ? undefined : (0, ConversationMessageProfileDto_1.ConversationMessageProfileDtoFromJSON)(json['profile']),
    };
}
function ConversationMessageDtoToJSON(json) {
    return ConversationMessageDtoToJSONTyped(json, false);
}
function ConversationMessageDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'role': value['role'],
        'content': value['content'],
        'toolCalls': value['toolCalls'] == null ? undefined : (value['toolCalls'].map(ToolCallDto_1.ToolCallDtoToJSON)),
        'profile': (0, ConversationMessageProfileDto_1.ConversationMessageProfileDtoToJSON)(value['profile']),
    };
}
//# sourceMappingURL=ConversationMessageDto.js.map